function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.863 5.754V3.762C4.863 1.684 6.715 0 9 0c2.285 0 4.137 1.684 4.137 3.762v1.992h2.316a.5.5 0 01.493.415l1.952 11.245a.5.5 0 01-.492.586H.594a.5.5 0 01-.492-.586L2.054 6.17a.5.5 0 01.493-.415h2.316zm.974 0h6.326V3.762C12.163 2.173 10.747.885 9 .885c-1.747 0-3.163 1.288-3.163 2.877v1.992zm0 2.316a.81.81 0 11-.974 0V7.002a1.786 1.786 0 10.974 0V8.07zm7.3 0a.81.81 0 11-.974 0V7.002a1.786 1.786 0 10.974 0V8.07z"
});

function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgShop;